var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"ui-btn",style:({ width: _vm.width }),attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_vm._t("default",[_vm._v(" "+_vm._s(_vm.btnText)+" ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }